import React from 'react';
import SampleTemplate from './SampleTemplate';
import { loadPlayer, checkIfSampleExist, getDefaultPlayerVersion } from '../../helpers/tools';

class Samples extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      playerName: '',
      playerVersion: '',
      playerPreloader: true,
    };

    this.intervalID = null;
    this.playerContainerId = 'player_container';
    this.defaultPlayerName = 'video';
    this.defaultPlayerVersion = '0';
  }

  registerPlugin = api => {
    if (globalThis.sas !== 'undefined' && globalThis.sas.video !== 'undefined') {
      this.setState({
        playerPreloader: false,
      });
      if (this.intervalID !== null) {
        globalThis.clearInterval(this.intervalID);
      }
      globalThis.sas.video.register({
        id: this.playerContainerId,
        contentPlayer: {
          api: api,
        },
        adData: {
          sas_siteid: '44928',
          sas_pageid: '901111',
          sas_format_linears: '27153',
          sas_format_overlays: '27154',
        },
        adRules: [
          {
            duration_min: 0,
            duration_max: -1,
            data: {
              prerolls: {
                instances: 1,
              },
              midrolls: {
                instances: 1,
                percents: [50],
              },
              postrolls: {
                instances: 1,
              },
              overlays: {
                instances: 1,
                percents: [10],
              },
            },
          },
        ],
        configuration: {
          publisher: {
            forceSkipDelay: true,
            html5SeamlessFullscreen: true,
            skipDelay: 3,
          },
          companions: {
            remove: true,
            slot: 'companionDiv1',
          },
        },
      });
    } else {
      if (this.intervalID !== null) {
        globalThis.clearInterval(this.intervalID);
      }
      this.intervalID = globalThis.setInterval(
        (() => {
          this.registerPlugin(api);
        }).bind(this),
        100
      );
    }
  };

  componentDidMount() {
    if (this.props.location && this.props.location.pathname) {
      let path = this.props.location.pathname.split('/'),
        playerName = this.defaultPlayerName,
        playerVersion = this.defaultPlayerVersion;
      if (path.length > 3) {
        playerVersion = path[3];
        playerName = path[2];
      }

      if (!checkIfSampleExist(playerName, playerVersion)) {
        if (checkIfSampleExist(playerName)) {
          playerVersion = getDefaultPlayerVersion(playerName);
        } else {
          playerName = this.defaultPlayerName;
          playerVersion = this.defaultPlayerVersion;
        }
      }
      loadPlayer(
        playerName,
        playerVersion,
        this.playerContainerId,
        false,
        true,
        this.registerPlugin
      );
      this.setState({
        playerVersion: playerVersion,
        playerName: playerName,
      });
    }
  }

  render() {
    return (
      <div>
        <SampleTemplate
          playerName={this.state.playerName}
          playerVersion={this.state.playerVersion}
          playerContainerId={this.playerContainerId}
          playerPreloader={this.state.playerPreloader}
        />
      </div>
    );
  }
}

export default Samples;
